import { Component} from '@angular/core';

@Component({
  selector: 'app-portfolio-four-column',
  templateUrl: './portfolio-three.component.html',
  styleUrl: './portfolio-three.component.css'
})
export class PortfolioFourColumnComponent {
  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // Portfolio Items
  portfolioItems = [
    {
      title: 'Red Record Disk',
      category: 'Creative',
      categoryClass: 'category-creative',
      image: 'assets/images/portfolio/gallery-1.jpg'
    },
    {
      title: 'Mobile App',
      category: 'Branding',
      categoryClass: 'category-branding',
      image: 'assets/images/portfolio/gallery-2.jpg'
    },
    {
      title: 'Pink Mockup',
      category: 'Creative',
      categoryClass: 'category-creative',
      image: 'assets/images/portfolio/gallery-3.jpg'
    },
    {
      title: 'Product Design',
      category: 'Branding',
      categoryClass: 'category-branding',
      image: 'assets/images/portfolio/gallery-4.jpg'
    },
    {
      title: 'Pink Mockup',
      category: 'Creative',
      categoryClass: 'category-creative',
      image: 'assets/images/portfolio/gallery-5.jpg'
    },
    {
      title: 'Product Design',
      category: 'Branding',
      categoryClass: 'category-branding',
      image: 'assets/images/portfolio/gallery-6.jpg'
    }
  ];
}
